import { render } from "./Archive_items.vue?vue&type=template&id=1bd405b1"
import script from "./Archive_items.vue?vue&type=script&lang=js"
export * from "./Archive_items.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__